export const HOME_PAGE = 'dashboard';
export const PROVIDER = 'provider';
export const LOGIN_PAGE = 'auth';
export const MY_PROFILE_URL = 'my-profile';
export const QUESTIONNAIRE_URL = 'questionnaire';
export const NULL_PAGE = 'null-page';
export const SESSION_USER = 'sessionUser';
export const ACCESS_TOKEN = 'access_token';
export const MAX_UPLOAD_FILE_SIZE = 31457280; //30 mb in bytes
export const MAX_SMALL_UPLOAD_FILE_SIZE = 3145728; //3 mb in bytes
export const DEFAULT_SESSION_TIME = 300;
export const SESSION_POLLING_TIME = 600000; // 10 minutes in milliseconds
export const PURCHASE_DIALOG_ID = 'purchase-dialog';

export const INPUT_DATE_FORMAT = 'dd/MM/yyyy';
export const FILTER_DATE_FORMAT = 'yyyy-LL-dd';
export const DISPLAY_DATE_FORMAT = 'MMM dd, yyyy';

export const MY_FORMATS = {
  parse: {
    dateInput: ['dd.MM.yyyy', 'dd/MM/yyyy', 'MM/dd/yyyy', FILTER_DATE_FORMAT],
  },
  display: {
    dateInput: 'dd/LL/yyyy',
    monthYearLabel: 'LLL yyyy',
    dateA11yLabel: DISPLAY_DATE_FORMAT,
    monthYearA11yLabel: 'MMMM yyyy',
  },
} as const;

export const DIALOG_SIZE = {
  MODAL_XS: '360px',
  MODAL_SM: '480px',
  MODAL_SM_UP: '560px',
  MODAL_MD_DOWN: '650px',
  MODAL_MD: '768px',
  MODAL_MD_LG: '820px',
  MODAL_MD_UP: '1024px',
  MODAL_LG: '1200px',
  MODAL_XL: '1440px',
} as const;

export type DialogSize = (typeof DIALOG_SIZE)[keyof typeof DIALOG_SIZE];

export const DIALOG_MODE = {
  CREATING: 'create',
  READING: 'read',
  ANSWERING: 'Answering',
  EDITING: 'edit',
  DELETING: 'delete',
} as const;

export type DialogMode = (typeof DIALOG_MODE)[keyof typeof DIALOG_MODE];

export const ALIGNMENT = {
  START: 'start',
  CENTER: 'center',
  END: 'end',
} as const;

export type Alignment = (typeof ALIGNMENT)[keyof typeof ALIGNMENT];

export const LOGIN_ACTION = {
  PASSWORD_AUTH: 'PASSWORD_AUTH',
  TWO_FACTOR_AUTH: 'TWO_FACTOR_AUTH',
  SIGNUP: 'SIGNUP',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  SIGNUP_NEW_USER: 'SIGNUP_NEW_USER',
  SAML: 'SAML',
  CONTACT_UME: 'CONTACT_UME',
} as const;

export type LoginAction = (typeof LOGIN_ACTION)[keyof typeof LOGIN_ACTION];

export const USER_STATUS = {
  CONTACT: 'CONTACT',
  ONBOARDING: 'ONBOARDING',
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  TECHNICAL: 'TECHNICAL',
  NOTIFICATION: 'NOTIFICATION',
} as const;

export type UserStatus = (typeof USER_STATUS)[keyof typeof USER_STATUS];

export const USER_ONBOARDING_STATUS = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  CANCELED: 'CANCELED',
  DELETED: 'DELETED',
} as const;

export type UserOnboardingStatus =
  (typeof USER_ONBOARDING_STATUS)[keyof typeof USER_ONBOARDING_STATUS];

export const APP_ROLE = {
  ADMIN: '__ADMIN',
  SECURITY_ADMIN: '__SECURITY_ADMIN',
  DDQ_SUBMIT: '__SUBMIT_QUESTIONNAIRE',
  DDQ_VIEW: '__MY_QUESTIONNAIRE/VIEW',
  DDQ_EDIT: '__MY_QUESTIONNAIRE/EDIT',
  QUESTIONNAIRE_MANAGE: '__QUESTIONNAIRE/MANAGE',
  NOTIFICATION: '__NOTIFICATION',
  MANAGE_SCORING: '__MANAGE_SCORING',
  ANSWER_QUEST_SECTION: '__ANSWER_QUESTIONNAIRE_SECTION',
  VALIDATE_SECTION: '__VALIDATE_SECTION',
  PREPARE_ASSESSMENT: '__PREPARE_ASSESSMENT',
  VALIDATE_ASSESSMENT: '__VALIDATE_ASSESSMENT',
  VIEW_ASSESSMENT: '__VIEW_ASSESSMENT',
  DELETE_DISTRIBUTOR: '__DELETE_DISTRIBUTOR',
  ARCHIVE_COUNTERPARTY: '__ARCHIVE_COUNTERPARTY',
  REQUEST_POLICIES: '__REQUEST_POLICIES',
  NETWORK_MANAGER_VIEW: '__NETWORK_MANAGER/VIEW',
  NETWORK_MANAGER_EDIT: '__NETWORK_MANAGER/EDIT',
  LABEL_MANAGEMENT: '__LABEL_MANAGEMENT',
  OWN_KYC: '__OWN_KYC',
  OWN_KYC_VIEW: '__OWN_KYC/VIEW',
  OWN_KYC_EDIT: '__OWN_KYC/EDIT',
  OWN_DFT_VIEW: '__MY_DFT/VIEW',
  OWN_DFT_EDIT: '__MY_DFT/EDIT',
  OWN_KPI_VIEW: '__MY_KPI/VIEW',
  OWN_KPI_EDIT: '__MY_KPI/EDIT',
  KYC_VIEW_ONLY: '__COUNTERPARTY_KYC/VIEW',
  KYC_VIEW_DOWNLOAD: '__COUNTERPARTY_KYC/DOWNLOAD',
  KYC_VIEW_MANAGE: '__COUNTERPARTY_KYC/MANAGE',
  CONFIGURE_CUSTOM_FIELDS: '__CONFIGURE_CUSTOM_FIELDS',
  EDIT_GENERAL_INFORMATION: '__EDIT_GENERAL_INFORMATION',
  VALIDATE_GENERAL_INFORMATION: '__VALIDATE_GENERAL_INFORMATION',
  ONBOARD_NEW_USER: '__ONBOARD_NEW_USER',
  INVITE_COUNTERPARTIES: '__INVITE_COUNTERPARTIES',
  OWN_FUNDS_EDIT: '__OWN_FUNDS/EDIT',
  OWN_FUNDS_VIEW: '__OWN_FUNDS/VIEW',
  OWN_FILES_VIEW: '__MY_FILES/VIEW',
  OWN_FILES_EDIT: '__MY_FILES/EDIT',
  SCREENING_VIEW: '__SCREENING/VIEW',
  SCREENING_MATCH_PROCESSING: '__SCREENING/MATCH_PROCESSING',
  SCREENING_ESCALATION: '__SCREENING/ESCALATION',
  ANALYTICS_VIEW: '__ANALYTICS/VIEW',
  API: '__API',
  DOCUMENT_ANALYSIS: '__DOCUMENT_ANALYSIS',
  MY_FOLLOW_UP_VIEW: '__MY_FOLLOW_UP/VIEW',
  MY_FOLLOW_UP_EDIT: '__MY_FOLLOW_UP/EDIT',
  COUNTERPARTY_FILES_VIEW: '__COUNTERPARTY_FILES/VIEW',
  COUNTERPARTY_FILES_EDIT: '__COUNTERPARTY_FILES/EDIT',
  KPI_VIEW: '__KPI/VIEW',
  KPI_EDIT: '__KPI/EDIT',
  MY_DFT_VIEW: '__MY_DFT/VIEW',
  MY_DFT_EDIT: '__MY_DFT/EDIT',
  DFT_VIEW: '__DFT/VIEW',
  DFT_EDIT: '__DFT/EDIT',
  QUESTIONNAIRE_VIEW: '__QUESTIONNAIRE/VIEW',
  QUESTIONNAIRE_EDIT: '__QUESTIONNAIRE/EDIT',
  COUNTERPARTY_KYC_EDIT: '__COUNTERPARTY_KYC/EDIT',
  MY_ACCOUNT_SERVICES: '__MY_ACCOUNT_SERVICES',
  DELETE_COMPANY: '__DELETE_COMPANY',
  ACTIVATE_COMPANY: '__ACTIVATE_COMPANY',
  COMPANY_DETAILS_EDIT: '__COMPANY_DETAILS/EDIT',
  COMPANY_DETAILS_VIEW: '__COMPANY_DETAILS/VIEW',
} as const;

export type AppRole = (typeof APP_ROLE)[keyof typeof APP_ROLE];

export const DDQ_STATUS_NETWORK_MANAGER = {
  EXPIRING: 'EXPIRING',
  EXPIRED: 'EXPIRED',
  NO_DDQ: 'NO_DDQ',
  UP_TO_DATE: 'UPTODATE',
} as const;

export type DDQNetworkManagementStatus =
  (typeof DDQ_STATUS_NETWORK_MANAGER)[keyof typeof DDQ_STATUS_NETWORK_MANAGER];

export const DDQ_SECTION_SHORT_NAME = {
  OPM: 'OPM',
  KYC: 'KYC',
  COM: 'COM',
  DIS: 'DIS',
  RM: 'RM',
  GOV: 'GOV',
  ESG: 'ESG',
} as const;

export type DDQSectionShortName =
  (typeof DDQ_SECTION_SHORT_NAME)[keyof typeof DDQ_SECTION_SHORT_NAME];

export const COMPANY_ACTION = {
  addContact: 'ADD_CONTACT',
  editContact: 'EDIT_USER',
  archive: 'ARCHIVE',
  assessment: 'ASSESSMENT',
  modularAssessment: 'MODULAR_ASSESSMENT',
  upgradeAssessment: 'UPGRADE_MODULAR_ASSESSMENT',
  unselectForAssessment: 'UNSELECT_FOR_ASSESSMENT',
  selectForAssessment: 'SELECT_FOR_ASSESSMENT',
  enableAssessment: 'ENABLE_ASSESSMENT',
  manageSelectedForAssessment: 'MANAGE_SELECTED_FOR_ASSESSMENT',
  undoUpgradeModularAssessment: 'UNDO_UPGRADE_MODULAR_ASSESSMENT',
  connect: 'CONNECT',
  ddqOnBehalf: 'PREPARE_DDQ_ON_BEHALF',
  delete: 'DELETE',
  reject: 'REJECT_ACCESS',
  getRegistrationLink: 'REGISTRATION_LINK',
  subscription: 'PURCHASE',
  putOnHold: 'PUT_ON_HOLD',
  send: 'SEND_REQUEST',
  resend: 'RESEND_REQUEST',
  resume: 'RESUME',
  sendForValidation: 'SEND_FOR_VALIDATION_DDQ_ON_BEHALF',
  invite: 'INVITE',
  restoreConnection: 'RESTORE_CONNECTION',
  requestReports: 'REQUEST_REPORTS',
  prepareKpiOnBehalf: 'PREPARE_KPI_ON_BEHALF',
  prepareKycOnBehalf: 'PREPARE_KYC_ON_BEHALF',
  disableSharing: 'DISABLE_SHARING',
  enableSharing: 'ENABLE_SHARING',
} as const;

export type CompanyAction = (typeof COMPANY_ACTION)[keyof typeof COMPANY_ACTION];

export const OVERSIGHT_GROUP_STATUS = {
  REQUEST_NOT_SENT: 'REQUEST_NOT_SENT',
  REQUEST_PENDING: 'REQUEST_PENDING',
  SUSPENDED: 'SUSPENDED',
  OUTDATED: 'OUTDATED',
  INTERNAL: 'INTERNAL',
  ARCHIVED: 'ARCHIVED',
  CONNECTED: 'CONNECTED',
} as const;

export type OversightGroupStatus =
  (typeof OVERSIGHT_GROUP_STATUS)[keyof typeof OVERSIGHT_GROUP_STATUS];

export const STATUS_GROUP_LABELS = {
  [OVERSIGHT_GROUP_STATUS.REQUEST_NOT_SENT]: 'Request not sent',
  [OVERSIGHT_GROUP_STATUS.REQUEST_PENDING]: 'Request pending',
  [OVERSIGHT_GROUP_STATUS.SUSPENDED]: 'Suspended',
  [OVERSIGHT_GROUP_STATUS.OUTDATED]: 'Outdated',
  [OVERSIGHT_GROUP_STATUS.INTERNAL]: 'Internal',
  [OVERSIGHT_GROUP_STATUS.CONNECTED]: 'Connected',
};

export const OVERSIGHT_STATUS = {
  /**
   * Need a description
   */
  OUTDATED: 'OUTDATED',
  /**
   * I have put the counterparty on the platform but I did not sent yet a request.
   */
  REQUEST_NOT_SENT: 'REQUEST_NOT_SENT',

  REQUEST_NOT_READY: 'REQUEST_NOT_READY',
  UNDER_REVIEW_BY_UME: 'UNDER_REVIEW_BY_UME',
  /**
   * I have received a request from a counterparty and I need to accept it to share my DDQ / receive its DDQ.
   */
  REQUEST_RECEIVED: 'REQUEST_RECEIVED',
  /**
   * I have sent a request and I am waiting that the counterparty completes it's DDQ / share with me its DDQ.
   */
  REQUEST_SENT: 'REQUEST_SENT',
  /**
   * I have received a DDQ from the counterparty and I shared my DDQ.
   */
  DDQ_SHARED: 'DDQ_SHARED',
  /**
   * I have decided not to chase longer this counterparty.
   */
  BLOCKED_ON_HOLD: 'BLOCKED_ON_HOLD',
  /**
   * I have denied the access to my DDQ.
   */
  BLOCKED_DENIED: 'BLOCKED_DENIED',
  /**
   * My counterparty refuses to share their DDQ with me.
   */
  BLOCKED_BLOCKED: 'BLOCKED_BLOCKED',
  /**
   * Request is refused by UMI.
   */
  REFUSED: 'REFUSED',
  /**
   * I have put the counterparty on the platform but I don't plan to bother them to reply.
   */
  INTERNAL: 'INTERNAL',
  /**
   * I have archived this counterparty.
   */
  ARCHIVED: 'ARCHIVED',
  /**
   * I have deleted this counterparty.
   */
  DELETED: 'DELETED',
  /**
   * I invited this counterparty with KPI.
   */
  NOT_INVITED: 'NOT_INVITED',
} as const;

export type OversightStatus = (typeof OVERSIGHT_STATUS)[keyof typeof OVERSIGHT_STATUS];

export const STATUS_LABELS = {
  [OVERSIGHT_GROUP_STATUS.SUSPENDED]: 'Suspended',
  [OVERSIGHT_GROUP_STATUS.REQUEST_PENDING]: 'Request pending',
  [OVERSIGHT_GROUP_STATUS.REQUEST_NOT_SENT]: 'Request not sent',
  [OVERSIGHT_GROUP_STATUS.CONNECTED]: 'Connected',
  [OVERSIGHT_STATUS.REQUEST_NOT_READY]: 'Incomplete',
  [OVERSIGHT_STATUS.UNDER_REVIEW_BY_UME]: 'Under validation',
  [OVERSIGHT_STATUS.REQUEST_RECEIVED]: 'Received',
  [OVERSIGHT_STATUS.REQUEST_SENT]: 'Sent',
  [OVERSIGHT_STATUS.DDQ_SHARED]: 'Shared',
  [OVERSIGHT_STATUS.BLOCKED_BLOCKED]: 'Blocked',
  [OVERSIGHT_STATUS.BLOCKED_ON_HOLD]: 'On hold',
  [OVERSIGHT_STATUS.BLOCKED_DENIED]: 'Denied',
  [OVERSIGHT_STATUS.INTERNAL]: 'Internal',
  [OVERSIGHT_STATUS.ARCHIVED]: 'Archived',
  [OVERSIGHT_STATUS.DELETED]: 'Deleted',
  [OVERSIGHT_STATUS.OUTDATED]: 'Outdated',
  [OVERSIGHT_STATUS.REFUSED]: 'Invalid',
  [OVERSIGHT_STATUS.NOT_INVITED]: 'Not invited',
};

export const STATUS_COLORS = {
  [OVERSIGHT_STATUS.REQUEST_RECEIVED]: '#008a83',
  [OVERSIGHT_STATUS.REQUEST_SENT]: '#89c997',
  [OVERSIGHT_STATUS.REQUEST_NOT_READY]: '#f39800',
  [OVERSIGHT_STATUS.UNDER_REVIEW_BY_UME]: '#ffff00',
  [OVERSIGHT_STATUS.DDQ_SHARED]: '#003567',
  [OVERSIGHT_STATUS.BLOCKED_BLOCKED]: '#c6006f',
  [OVERSIGHT_STATUS.BLOCKED_ON_HOLD]: '#f19ec2',
  [OVERSIGHT_STATUS.BLOCKED_DENIED]: '#ec6d7b',
  [OVERSIGHT_STATUS.REFUSED]: '#ff69b4',
  [OVERSIGHT_STATUS.INTERNAL]: '#aeaaaa',
  [OVERSIGHT_STATUS.ARCHIVED]: '#424242',
  [OVERSIGHT_STATUS.DELETED]: '#333333',
  [OVERSIGHT_STATUS.OUTDATED]: '#d7000f',
  [OVERSIGHT_STATUS.NOT_INVITED]: '#d7000f',
  [OVERSIGHT_GROUP_STATUS.REQUEST_NOT_SENT]: '#ffd700',
  [OVERSIGHT_GROUP_STATUS.SUSPENDED]: '#8a017c',
  [OVERSIGHT_GROUP_STATUS.REQUEST_PENDING]: '#567c03',
  [OVERSIGHT_GROUP_STATUS.CONNECTED]: '#00b0f1',
};

// keys order is important (UCH-2234)
export const ONBOARDING_OPTIONS = {
  REQUEST_DDQ: 'REQUEST_DDQ', // requesting company needs to up to date its DDQ ( show contact form )
  SHARE_DDQ: 'SHARE_DDQ', // my DDQ is up to date ( show contact form )
  REQUEST_FILES_ONLY: 'REQUEST_FILES_ONLY', // non intermediaries
  REQUEST_FILES_KYC_ONLY: 'REQUEST_FILES_ONLY', // alias — KYC files + investor-specific variant
  REQUEST_REPORTS: 'REQUEST_REPORTS', // onboarding option for invitation via Reporting request
  SHARE_KPI: 'SHARE_KPI', // invited via KPI
  SHARE_REPORTING: 'SHARE_REPORTING',
  INVITE_INVESTOR: 'INVITE_INVESTOR',
  onboardSubAccount: 'ONBOARD_SUB_ACCOUNT', // for onboard sub account
  ALREADY_EXISTS: 'ERR_ALREADY_EXISTS',
  PRICE_ALERT: 'PRICE_ALERT', // REGULAR DDQ SHARE 700oyro
} as const;

export type OnboardingOptions = (typeof ONBOARDING_OPTIONS)[keyof typeof ONBOARDING_OPTIONS];
export type OnboardingOptionsAccess = Record<OnboardingOptions, string | null>;

export const ONBOARDING_REQUEST_TYPE = {
  /**
   * The intent to request the DDQ.
   */
  REQUEST_DDQ: 'REQUEST_DDQ',
  /**
   * The intent share the own DDQ with the counterparties.
   */
  SHARE_OWN_DDQ_ONLY: 'SHARE_OWN_DDQ_ONLY',
  REQUEST_FILES_ONLY: 'REQUEST_FILES_ONLY',
  SHARE_KPI: 'SHARE_KPI',
  ONBOARD_SUB_ACCOUNT: 'ONBOARD_SUB_ACCOUNT',
  /**
   * The intent share the UK Consumer Duty reports with the counterparties.
   */
  SHARE_REPORTING: 'SHARE_REPORTING',
  REQUEST_REPORTS: 'REQUEST_REPORTS',
  INVITE_INVESTOR: 'INVITE_INVESTOR',
} as const;

export type OnboardingRequestType =
  (typeof ONBOARDING_REQUEST_TYPE)[keyof typeof ONBOARDING_REQUEST_TYPE];

export const DISABLE_REASON = {
  SUBSCRIPTION_MISSING: 'SUBSCRIPTION_MISSING',
  OWN_DDQ_NOT_UP_TO_DATE: 'OWN_DDQ_NOT_UP_TO_DATE',
  ACCESS_DENIED: 'ACCESS_DENIED',
  NOT_IMPLEMENTED_YET: 'NOT_IMPLEMENTED_YET',
  REGISTRATION_LINK_COUNTERPARTY_ALREADY_SIGNED_IN:
    'REGISTRATION_LINK_COUNTERPARTY_ALREADY_SIGNED_IN',
} as const;

export type DisableReason = (typeof DISABLE_REASON)[keyof typeof DISABLE_REASON];

export const WELCOME_SCREEN = {
  HOME_PAGE: 'HOME_PAGE',
  KPI: 'KPI',
} as const;

export type WelcomeScreen = (typeof WELCOME_SCREEN)[keyof typeof WELCOME_SCREEN];

export const ERROR_CODES = {
  INTERNAL_ERROR: '__UME_INTERNAL_SERVER_ERROR',
  MICRO_SERVICE_ERROR: '__UME_MICRO_SERVICE_ERROR',
  PASS_BLOCKED: '__UME_PASSWORD_AUTH_BLOCKED',
  UNAUTHORIZED: '__UME_UNAUTHORISED',
  REQUEST_CODE_BLOCKED: '__UME_REQUEST_BLOCKED',
} as const;

export type ErrorCodes = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

export const REQUEST_INITIATOR = {
  SENT: 'REQUEST_SENT',
  RECEIVED: 'REQUEST_RECEIVED',
} as const;

export const MERGE_CONFLICTS = {
  ERR_NETWORK_CONFLICT: 'ERR_NETWORK_CONFLICT',
  ERR_DRAFT_DDQ_CONFLICT: 'ERR_DRAFT_DDQ_CONFLICT',
  ERR_SUBMITTED_DDQ_CONFLICT: 'ERR_SUBMITTED_DDQ_CONFLICT',
  ERR_MANDATORY_DOC_CONFLICT: 'ERR_MANDATORY_DOC_CONFLICT',
  ERR_COUNTRY_CONFLICT: 'ERR_COUNTRY_CONFLICT',
  ERR_VIRTUAL_PREMIUM: 'ERR_VIRTUAL_PREMIUM',
} as const;

export type MergeConflicts = (typeof MERGE_CONFLICTS)[keyof typeof MERGE_CONFLICTS];

export const INVITATION_TYPE = {
  KPI_INVITATION: 'KPI_Invite',
  DFT_INVITATION: 'DFT_Invite',
};

export type InvitationType = (typeof INVITATION_TYPE)[keyof typeof INVITATION_TYPE];

export const ONBOARDING_INVITATION_TYPE = {
  REQUEST_SENT: 'REQUEST_SENT',
  REQUEST_RECEIVED: 'REQUEST_RECEIVED',
};

export type OnboardingRequestInitiator =
  (typeof ONBOARDING_INVITATION_TYPE)[keyof typeof ONBOARDING_INVITATION_TYPE];

export const ERROR_VALIDATION_MODAL_TYPES = {
  KYC: 'KYC',
  CONSUMER_DUTY: 'CONSUMER_DUTY',
} as const;

export type ErrorValidationModalType =
  (typeof ERROR_VALIDATION_MODAL_TYPES)[keyof typeof ERROR_VALIDATION_MODAL_TYPES];
